import Icon from "@/components/icon";
import { useAudioControls } from "../hooks/use-audio-controls";

const PlayPauseButton: React.FC = () => {
  const { isPlaying, isAudioReady, isResolving, togglePlay } = useAudioControls();

  return (
    <button
      onClick={togglePlay}
      disabled={isResolving || (!isAudioReady && isPlaying)}
      className="p-3 rounded-full bg-primary text-white disabled:opacity-60"
      title={isPlaying ? "Pause" : "Play"}
    >
      {isPlaying ? (
        <Icon name="pause-fill" className="size-4" />
      ) : (
        <Icon name="play-fill" className="size-4" />
      )}
    </button>
  );
};

export default PlayPauseButton;
